'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _ButtonToggle = require('../../blocks/ButtonToggle');

var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionLabel = _ButtonToggle2.default.OptionLabel,
    Bar = _ButtonToggle2.default.Bar,
    Switch = _ButtonToggle2.default.Switch,
    Checkbox = _ButtonToggle2.default.Checkbox,
    Content = _ButtonToggle2.default.Content;

var ButtonToggle = function (_Component) {
  _inherits(ButtonToggle, _Component);

  function ButtonToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ButtonToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonToggle.__proto__ || Object.getPrototypeOf(ButtonToggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      options: []
    }, _this.cloneOption = function (option, isDefaultOption) {
      return _react2.default.cloneElement(option, {
        modifiers: [isDefaultOption ? 'active' : 'inactive']
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ButtonToggle, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.parseChildren();
    }
  }, {
    key: 'parseChildren',
    value: function parseChildren() {
      var options = [];
      _react2.default.Children.forEach(this.props.children, function (child) {
        if (child.type === OptionLabel) {
          options.push(child);
        }
      });
      this.setState({ options: options });
    }
  }, {
    key: 'renderButtonContent',
    value: function renderButtonContent() {
      if (!this.state.options.length) {
        return null;
      }

      return _react2.default.createElement(
        Content,
        null,
        this.cloneOption(this.state.options[0], !this.props.on),
        _react2.default.createElement(
          Bar,
          null,
          _react2.default.createElement(Switch, { modifiers: (0, _lodash.compact)([this.props.on && 'on']) })
        ),
        this.cloneOption(this.state.options[1], this.props.on)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          on = _props.on,
          _onClick = _props.onClick;


      return _react2.default.createElement(
        _ButtonToggle2.default,
        {
          modifiers: (0, _lodash.compact)([disabled && 'disabled']),
          onClick: function onClick() {
            return _onClick(on);
          }
        },
        _react2.default.createElement(Checkbox, {
          checked: on,
          disabled: disabled,
          onChange: function onChange() {
            return _onClick(on);
          }
        }),
        this.renderButtonContent()
      );
    }
  }]);

  return ButtonToggle;
}(_react.Component);

ButtonToggle.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  on: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
ButtonToggle.defaultProps = {
  disabled: false,
  on: true,
  onClick: _lodash.noop
};


ButtonToggle.OnLabel = OptionLabel;
ButtonToggle.OffLabel = OptionLabel;

exports.default = ButtonToggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/ButtonToggle/index.js
// module id = 1621
// module chunks = 2